import styled from 'styled-components';
import {DIMENSION} from '../../constants';
export const RoutineFormContainer = styled.div`
  padding: 0;
`;